import { isEmpty } from 'lodash'

const WAVEFORM_BAR_COLOR = 'rgb:282636'
const WAVEFORM_BACKGROUND_COLOR = 'transparent'
const WAVEFORM_WIDTH = '700'
const WAVEFORM_HEIGHT = '200'

const cloudinaryCloudName = process.env.REACT_APP_CLOUDINARY_CLOUDNAME
const mediaServiceBaseUrl = process.env.REACT_APP_MEDIASERVICE_BASE_URL

const cloudinaryUserAssetUrl = process.env.REACT_APP_ENV === 'production' ?
  'https://media.plickers.com/' : 'https://media.plickers-dev.com/'

const mediaServiceUserAssetUrl = `${mediaServiceBaseUrl}/${cloudinaryCloudName}/`

function shouldPresentMediaService() {
  return process.env.REACT_APP_WEB_NON_MAIN_USE_MEDIASERVICE === 'true'
}

function collapseMultipleSlashes(str) {
  return str.replace(/(^\w+:\/\/)|\/{2,}/g, (_, protocol) => (protocol || '/'))
}

function getMediaBaseUrl(baseUrl, options = {}) {
  const optionsToUse = { resource: 'image', delivery: 'upload', ...options }
  const resourceAndDelivery = `${optionsToUse.resource}/${optionsToUse.delivery}/`
  return collapseMultipleSlashes(`${baseUrl}${resourceAndDelivery}/`)
}

function composeDeliveryUrl(baseUrl, publicId, options = {}) {
  const transformationString = isEmpty(options.transformations) ? '' : `${options.transformations}/`
  const versionString = options.version ? `${options.version}/` : ''
  const folderPathString = options.folderPath ? `${options.folderPath}/` : ''
  const formatString = options.format ? `.${options.format}` : ''
  return collapseMultipleSlashes(`${getMediaBaseUrl(baseUrl, options)}${transformationString}${versionString}${folderPathString}${publicId}${formatString}`)
}

function conformDeliveryUrlToMediaService(deliveryUrl) {
  const shouldUseMediaService = shouldPresentMediaService()
  if (!deliveryUrl || !deliveryUrl.includes(cloudinaryUserAssetUrl)) {
    return deliveryUrl
  }
  if (shouldUseMediaService) {
    const newDeliveryUrl = deliveryUrl.replace(cloudinaryUserAssetUrl, mediaServiceUserAssetUrl)
    return newDeliveryUrl
  }
  return deliveryUrl
}

function getSoundDeliveryUrl(
  publicId,
  start = null,
  end = null,
  isClipped = false,
  withFormat = true,
) {
  const transformations = isClipped ? `so_${start},eo_${end}/` : ''
  return composeDeliveryUrl(cloudinaryUserAssetUrl, publicId, { resource: 'video', transformations, format: withFormat ? 'mp3' : null })
}

function getSoundWaveformUrl(publicId, start = null, end = null, isClipped = false) {
  const clipString = isClipped ? `so_${start},eo_${end}/` : ''
  const transformations = `${clipString}h_${WAVEFORM_HEIGHT},w_${WAVEFORM_WIDTH},fl_waveform,co_${WAVEFORM_BAR_COLOR},b_${WAVEFORM_BACKGROUND_COLOR}/`
  return composeDeliveryUrl(cloudinaryUserAssetUrl, publicId, { resource: 'video', transformations, format: 'png' }) // use png for Safari support
}

export {
  getSoundDeliveryUrl,
  getSoundWaveformUrl,
  conformDeliveryUrlToMediaService as conformDeliveryUrl,
}
